module.exports = __webpack_public_path__ + "static/media/loading_image.5fb0b492.svg";